var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0748 0.056216C6.62033 0.0306633 1.94666 3.32614 0.0374738 7.99991C1.90279 12.6914 6.54538 16.0305 11.9999 16.056C17.4544 16.0816 22.128 12.7861 24.0372 8.11234C22.1719 3.42089 17.5293 0.0817688 12.0748 0.056216ZM12.0498 5.38949C13.5553 5.39654 14.7715 6.59692 14.7646 8.0689C14.7577 9.54089 13.5303 10.7298 12.0248 10.7228C10.5194 10.7157 9.3032 9.51534 9.3101 8.04335C9.317 6.57137 10.5444 5.38244 12.0498 5.38949ZM12.0598 3.25618C9.3544 3.24351 7.1407 5.38783 7.12831 8.03313C7.11591 10.6784 9.30943 12.8434 12.0149 12.8561C14.7203 12.8688 16.934 10.7244 16.9464 8.07913C16.9588 5.43382 14.7653 3.26886 12.0598 3.25618Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0373 8.0796C17.0244 10.841 14.7762 12.869 12.0149 12.8561C9.25346 12.8431 7.02446 10.7941 7.0374 8.03275C7.05033 5.27136 9.29843 3.24324 12.0598 3.25618C14.8212 3.26912 17.0502 5.31821 17.0373 8.0796Z",
    fill: "#FFF8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7373 8.06885C14.73 9.62212 13.5158 10.7631 12.0247 10.7561C10.5335 10.7492 9.33008 9.59682 9.33736 8.04356C9.34464 6.49029 10.5588 5.34922 12.05 5.35621C13.5411 5.36319 14.7446 6.51559 14.7373 8.06885Z",
    fill: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/EyeOff.88b21bba9fd88edd0fa0ee2f350847ad.svg";
export { ForwardRef as ReactComponent };